// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 243) return "js/npm.mui.a9d7c82b47c2e97b6bd9.bundle.js";
	if (chunkId === 23) return "js/npm.lodash.b6ec0ec271722d430cae.bundle.js";
	if (chunkId === 244) return "js/npm.lodash-es.451f218313e1cba75a55.bundle.js";
	if (chunkId === 90) return "js/npm.react-dom.339d52da691a07ff00f5.bundle.js";
	if (chunkId === 386) return "js/npm.axios.1d23757a20693cb8c61e.bundle.js";
	if (chunkId === 58) return "js/npm.ant-design.2d253d268564fe52717b.bundle.js";
	if (chunkId === 339) return "js/npm.mathjs.005d1d4955824707cf5b.bundle.js";
	if (chunkId === 523) return "js/npm.rc-component.f5cff4f7f3d48b0cd6ba.bundle.js";
	if (chunkId === 713) return "js/npm.antd.41d9f6950ad7770a601c.bundle.js";
	if (chunkId === 954) return "js/npm.refractor.23810830e29362594c58.bundle.js";
	if (chunkId === 861) return "js/npm.motion-dom.780e1dda64be23a36248.bundle.js";
	if (chunkId === 808) return "js/npm.moment.6c9b6eb242729fb1a983.bundle.js";
	if (chunkId === 840) return "js/npm.recharts.acab1958fbd81a6ef410.bundle.js";
	if (chunkId === 114) return "js/npm.framer-motion.e611421b6cf282ed94ce.bundle.js";
	if (chunkId === 714) return "js/npm.victory-core.2cefa83d2723c59ac6b7.bundle.js";
	if (chunkId === 254) return "js/npm.react-three.45e401e1ec38f9f2d9d4.bundle.js";
	if (chunkId === 950) return "js/npm.react-select.ec4cb6145334c8b916ed.bundle.js";
	if (chunkId === 909) return "js/npm.ag-grid-community.e562bfa5573bdb8da3bb.bundle.js";
	if (chunkId === 25) return "js/npm.js-beautify.92463b27a2eb245303c0.bundle.js";
	if (chunkId === 53) return "js/npm.dnd-kit.2c8f3bcdf319d4a75be6.bundle.js";
	if (chunkId === 240) return "js/npm.react-big-calendar.55a8d8a0873a0d71b392.bundle.js";
	if (chunkId === 628) return "js/npm.three.ad013bc063a391aa91d7.bundle.js";
	if (chunkId === 32) return "js/npm.pdfmake.31d601af4e7764935d18.bundle.js";
	if (chunkId === 558) return "js/npm.pdfmake-unicode.460ef395d8d710313829.bundle.js";
	if (chunkId === 185) return "js/npm.jspdf.f612f59b11971f148439.bundle.js";
	if (chunkId === 383) return "js/npm.html2canvas.e4b3ab9edd082c160bf4.bundle.js";
	if (chunkId === 859) return "js/npm.pako.1c16d04a7d568603cc4e.bundle.js";
	if (chunkId === 559) return "js/npm.katex.ea0c21ad0a9d7349ac88.bundle.js";
	if (chunkId === 212) return "js/npm.decimal.js.7e8d1d77e05c0e5a1356.bundle.js";
	if (chunkId === 407) return "js/npm.ag-grid-react.0c695b2fd9bf634a441a.bundle.js";
	if (chunkId === 933) return "js/933.2b8b009f4999a912f4f4.bundle.js";
	if (chunkId === 71) return "js/71.867d5bb27f0123eb00c3.bundle.js";
	if (chunkId === 575) return "js/edjin.25e6dad436479fafd852.bundle.js";
	if (chunkId === 603) return "js/npm.core-js.32fd1cf5df0651ab0c16.bundle.js";
	if (chunkId === 134) return "js/134.a70bda503477169e7847.bundle.js";
	if (chunkId === 617) return "js/SchoolClasses.934a58ddfac666993a52.bundle.js";
	if (chunkId === 997) return "js/997.75b7ec7bfe12f17d9591.bundle.js";
	if (chunkId === 727) return "js/npm.canvg.73d1b73fa072f9ef79e0.bundle.js";
	if (chunkId === 505) return "js/505.e979f269eea0fb987118.bundle.js";
	// return url for filenames based on template
	return undefined;
};